import { CompSearchExecutionContext } from './comp-search-execution-context';

export class CompSearchPayload {
  containerId: number;
  pbaId: number;
  jurisdictionId: number;
  executionContext: CompSearchExecutionContext;
}
